// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entry-row {
  width: 100%;
  height: 40px;
  align-items: center;
  display: flex;
  transition: background ease-in-out 0.2s;
  padding-left: 4px;
}
.entry-row_hoverable:hover {
  background: var(--g-color-base-simple-hover);
}
.entry-row_locked {
  color: var(--g-color-text-complementary);
}
.entry-row__text-block {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.entry-row__name {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-1-font-size);
  line-height: var(--g-text-body-1-line-height);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 10px;
}
.entry-row__entry {
  margin-right: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.entry-row__icon {
  flex-shrink: 0;
}
.entry-row__icon_disabled {
  opacity: 0.5;
}
.entry-row__locked-label {
  display: flex;
  gap: 8px;
  margin-left: 8px;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryRow/EntryRow.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EAEI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uCAAA;EACA,iBAAA;AAFJ;AAII;EACI,4CAAA;AAFR;AAKI;EACI,wCAAA;AAHR;AAMI;ECfA,mBAAA;EACA,gBAAA;EACA,uBAH4B;EDkBxB,gBAAA;EACA,aAAA;EACA,mBAAA;AAFR;AAKI;EC6IA,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;EAtKA,mBAAA;EACA,gBAAA;EACA,uBAH4B;ED0BxB,iBAAA;AAER;AACI;EACI,kBAAA;EAEA,gBAAA;EACA,aAAA;EACA,mBAAA;AAAR;AAGI;EACI,cAAA;AADR;AAGQ;EACI,YAAA;AADZ;AAKI;EACI,aAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;AAHR","sourcesContent":[".entry-row {\n  width: 100%;\n  height: 40px;\n  align-items: center;\n  display: flex;\n  transition: background ease-in-out 0.2s;\n  padding-left: 4px;\n}\n.entry-row_hoverable:hover {\n  background: var(--g-color-base-simple-hover);\n}\n.entry-row_locked {\n  color: var(--g-color-text-complementary);\n}\n.entry-row__text-block {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\n.entry-row__name {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-1-font-size);\n  line-height: var(--g-text-body-1-line-height);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-left: 10px;\n}\n.entry-row__entry {\n  margin-right: 10px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\n.entry-row__icon {\n  flex-shrink: 0;\n}\n.entry-row__icon_disabled {\n  opacity: 0.5;\n}\n.entry-row__locked-label {\n  display: flex;\n  gap: 8px;\n  margin-left: 8px;\n  flex-shrink: 0;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
